import * as React from 'react';
import { ProductBlockGallery } from '@grandvisionhq/lib-visuals';
import { ProductListingBlock } from '../ProductListingBlock/ProductListingBlock.js';

const ProductListingGallery = ({ products , isLoading , hasError , reimbursableLogos , productLocation , onProductImpression , onProductInteraction ,  })=>{
    const renderBlock = ({ blockKey , tabIndex , className  })=>{
        const productIndex = products.findIndex((product)=>product.masterVariant.sku === blockKey
        );
        const product1 = products[productIndex];
        if (!product1) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(ProductListingBlock, {
            key: blockKey,
            listingProduct: product1,
            reimbursableLogos: reimbursableLogos,
            className: className,
            tabIndex: tabIndex,
            productLocation: productLocation,
            onImpression: ()=>{
                return onProductImpression === null || onProductImpression === void 0 ? void 0 : onProductImpression(product1, productIndex);
            },
            onInteraction: ()=>{
                return onProductInteraction === null || onProductInteraction === void 0 ? void 0 : onProductInteraction(product1, productIndex);
            }
        });
    };
    return /*#__PURE__*/ React.createElement(ProductBlockGallery, {
        isLoading: isLoading,
        hasError: hasError,
        blockKeys: products.map((product)=>product.masterVariant.sku
        ),
        renderBlock: renderBlock
    });
};

export { ProductListingGallery };
//# sourceMappingURL=ProductListingGallery.js.map
